import {BaseWidgetConfiguration} from "../../../Contracts/WidgetTypes/BaseWidget";
import {WidgetOptionError} from "../Errors/WidgetOptionError";

const validateTrackingConfiguration = (config: any): config is BaseWidgetConfiguration['options']['tracking'] => {

    if(typeof config !== 'boolean')
    {
        throw WidgetOptionError.fromInvalidTracking();
    }
    return true;
}
export const areValidWidgetOptions = (config: any): config is BaseWidgetConfiguration['options'] => {
    if(config.tracking !== undefined) {
        validateTrackingConfiguration(config.tracking);
    }
    if(config.loggingLevel !== undefined && typeof config.loggingLevel !== 'string') {
        throw WidgetOptionError.fromWrongType('loggingLevel', 'string', config.loggingLevel);
    }
    if(config.loggingLevel !== undefined && !['debug' , 'warn', 'error'].includes(config.loggingLevel)) {
        throw WidgetOptionError.fromWrongType('loggingLevel', '[\'debug\' , \'warn\', \'error\'', config.loggingLevel);
    }
    if(config.crashReport !== undefined && typeof config.crashReport !== 'boolean') {
        throw WidgetOptionError.fromWrongType('crashReport', 'boolean', config.crashReport);
    }
    if(config.collectTraces !== undefined && typeof config.collectTraces !== 'boolean') {
        throw  WidgetOptionError.fromWrongType('collectTraces', 'boolean', config.collectTraces);
    }
    if(config.previewMode !== undefined && typeof config.previewMode !== 'boolean') {
        throw  WidgetOptionError.fromWrongType('previewMode', 'boolean', config.previewMode);
    }
    if(config.previewToken !== undefined && typeof config.previewToken !== 'string') {
        throw  WidgetOptionError.fromWrongType('previewToken', 'string', config.previewMode);
    }
    return true;
}

export const isValidCheckoutTheme = (theme: any): theme is BaseWidgetConfiguration['checkoutTheme'] => {
    if(typeof theme !== 'string') {
        throw WidgetOptionError.fromWrongType('checkoutTheme', 'string', theme);
    }
    return true;
}